// src/BoasVindasModal.jsx
import React, { useState } from "react";

export default function BoasVindasModal({ nomeUsuario = "", onClose }) {
  const [visible, setVisible] = useState(true);

  function handleClose() {
    setVisible(false);
    setTimeout(() => onClose?.(), 280);
  }

  const nome = (nomeUsuario || "").split(" ")[0];

  const recursos = [
    "📊 Relatórios e gráficos completos",
    "🐷 Assistente de voz Porquinho Ninja",
    "🔔 Alertas de contas no WhatsApp",
    "📈 Carteira de investimentos completa",
  ];

  return (
    <div style={{
      position:"fixed",inset:0,zIndex:9999,
      display:"flex",alignItems:"flex-end",justifyContent:"center",
      background:"rgba(0,0,0,0.5)",
      opacity:visible?1:0,
      transition:"opacity 0.28s ease",
      fontFamily:"Inter,ui-sans-serif,system-ui,sans-serif",
    }}>
      <div style={{
        width:"100%",maxWidth:480,
        background:"#13131f",
        border:"1px solid #2a2a3e",
        borderRadius:"24px 24px 0 0",
        padding:"28px 24px 48px",
        transform:visible?"translateY(0)":"translateY(100%)",
        transition:"transform 0.32s cubic-bezier(0.34,1.2,0.64,1)",
        display:"flex",flexDirection:"column",alignItems:"center",gap:16,
      }}>
        {/* Handle */}
        <div style={{width:36,height:4,borderRadius:2,background:"#2a2a3e",marginBottom:4}}/>

        {/* Ícone */}
        <div style={{
          width:72,height:72,borderRadius:"50%",
          background:"linear-gradient(135deg,#fde68a,#f59e0b)",
          display:"flex",alignItems:"center",justifyContent:"center",
          fontSize:36,boxShadow:"0 8px 24px rgba(245,158,11,0.35)",
          animation:"bvPop 0.5s cubic-bezier(0.34,1.56,0.64,1) 0.05s both",
        }}>🎉</div>

        {/* Título */}
        <div style={{textAlign:"center",animation:"bvUp 0.4s ease 0.15s both"}}>
          <h2 style={{fontSize:22,fontWeight:800,color:"#f8fafc",margin:"0 0 6px",lineHeight:1.2}}>
            {nome ? `Parabéns, ${nome}! 🎉` : "Parabéns! 🎉"}
          </h2>
          <p style={{fontSize:14,color:"#8f8fa4",margin:0}}>Você acabou de dar o primeiro passo rumo à sua liberdade financeira.</p>
        </div>

        {/* Card de boas-vindas simples, sem menção ao Premium ainda */}
        <div style={{
          width:"100%",
          background:"linear-gradient(135deg,#052e16,#064e3b)",
          border:"1.5px solid #10b981",
          borderRadius:16,padding:"18px",
          display:"flex",flexDirection:"column",gap:12,
          animation:"bvUp 0.4s ease 0.25s both",
        }}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:26}}>🌱</span>
            <div>
              <div style={{fontWeight:800,fontSize:15,color:"#6ee7b7"}}>
                Sua jornada começa agora
              </div>
              <div style={{fontSize:12,color:"#34d399",marginTop:2}}>
                Vamos te ajudar a organizar cada um dos 5 pilares.
              </div>
            </div>
          </div>
          <div style={{borderTop:"1px solid #065f46",paddingTop:12,display:"flex",flexDirection:"column",gap:8}}>
            {recursos.map((item,i)=>(
              <div key={i} style={{fontSize:13,color:"#a7f3d0",fontWeight:500}}>{item}</div>
            ))}
          </div>
        </div>

        {/* Botão */}
        <button onClick={handleClose} style={{
          width:"100%",padding:"15px",borderRadius:14,
          background:"linear-gradient(135deg,#10b981,#059669)",
          color:"#fff",fontWeight:800,fontSize:16,
          border:"none",cursor:"pointer",fontFamily:"inherit",
          boxShadow:"0 4px 20px rgba(16,185,129,0.4)",
          animation:"bvUp 0.4s ease 0.42s both",
        }}>
          Começar agora 🚀
        </button>
      </div>

      <style>{`
        @keyframes bvPop{from{opacity:0;transform:scale(0.6)}to{opacity:1;transform:scale(1)}}
        @keyframes bvUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
      `}</style>
    </div>
  );
}
